import { catchError, first, switchMap, throwError } from 'rxjs';
import { publicCredentials } from '../../Auth/Domain/PublicCredentials';
import AUTH_EXCEPTIONS from '../Infrastructure/Exception/APIv4AuthExceptionMap';
function authErrorCheck(error) {
  return AUTH_EXCEPTIONS.some(authException => error.message.includes(authException.exception.message));
}
/**
 *  This function will inject the secret-less credentials to the callback function & if the token becomes invalid will try to refresh it once
 * It is important to differentiate this type of token as it can be obtained
 * without user-identifying info which makes it usable without login processes and may enable
 * us to SSR/cache its results
 *
 * Currently the only implementation returns an Observable of the v4 oauth_public_token which is
 * subsequently used in other requests, such as "getProductByFeedId" or "RegisterCustomer."
 * The public token obtained from this method serves as a form of authentication or authorization
 * to access certain resources in the store.
 * The responsability of getting and managing the token is in SAM side. It is called
 * internally from the use cases that need a oauth_public_token.
 * @param AuthCredentialsRepository authRepository to call the
 * @param callBackFunction The callback function you want to execute, the token will be injected as first argument
 * @returns Observable<T> Will return the callbackFuntion result
 */
export function publicStoreCredentialsHandler(authRepository, callBackFunction) {
  return publicCredentials.getPublicStoreCredentials(authRepository).pipe(first(), switchMap(credentials => {
    return callBackFunction(credentials).pipe(catchError(error => {
      // TODO: this is a temporary solution, the infrastructure of the error check should be injected and not imported
      if (authErrorCheck(error)) {
        return authRepository.findByStore().pipe(switchMap(response => {
          publicCredentials.setNewCredentials(response);
          return callBackFunction(response);
        }));
      }
      return throwError(() => error);
    }));
  }));
}
